/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'navigation.global-shortcuts.all-sites': '모든 사이트',
  'navigation.global-shortcuts.apps.align': '정렬',
  'navigation.global-shortcuts.apps.analytics': '분석',
  'navigation.global-shortcuts.apps.assets': '자산',
  'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
  'navigation.global-shortcuts.apps.company-hub': '회사 허브',
  'navigation.global-shortcuts.apps.compass': 'Compass',
  'navigation.global-shortcuts.apps.confluence': 'Confluence',
  'navigation.global-shortcuts.apps.focus': 'Focus',
  'navigation.global-shortcuts.apps.goals': '목표',
  'navigation.global-shortcuts.apps.home': '홈',
  'navigation.global-shortcuts.apps.jira': 'Jira',
  'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
  'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
  'navigation.global-shortcuts.apps.loom': 'Loom',
  'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
  'navigation.global-shortcuts.apps.projects': '프로젝트',
  'navigation.global-shortcuts.apps.studio': 'Studio',
  'navigation.global-shortcuts.apps.talent': 'Talent',
  'navigation.global-shortcuts.apps.teams': '팀',
  'navigation.global-shortcuts.apps.trello': 'Trello',
  'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': '닫기',
  'navigation.global-shortcuts.menu-expand-item.site-aria-label': '{name} 사이트',
  'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(현재 사용할 수 없음)',
  'navigation.global-shortcuts.menu-link-item.link-external-item-label': '외부 링크 아이콘 열기',
  'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(로드 중)',
  'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(로드 중)',
  'navigation.global-shortcuts.shortcut-action.open-menu-label': '메뉴 열기',
  'navigation.global-shortcuts.sites': '{productName} 사이트',
};
